
import { Sun, Moon } from 'lucide-react'
import { useTheme } from '../contexts/ThemeContext'

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()

  return (
    <button
      onClick={toggleTheme}
      className="relative p-2 rounded-lg transition-all duration-200 hover:bg-nature-100 dark:hover:bg-nature-800 focus:outline-none focus:ring-2 focus:ring-nature-500 focus:ring-offset-2 dark:focus:ring-offset-nature-900"
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      <div className="relative w-5 h-5">
        <Sun 
          className={`absolute inset-0 w-5 h-5 transition-all duration-300 ${
            theme === 'light' 
              ? 'text-yellow-500 opacity-100 rotate-0' 
              : 'text-yellow-500 opacity-0 -rotate-90'
          }`}
        />
        <Moon 
          className={`absolute inset-0 w-5 h-5 transition-all duration-300 ${
            theme === 'dark' 
              ? 'text-blue-400 opacity-100 rotate-0' 
              : 'text-blue-400 opacity-0 rotate-90'
          }`}
        />
      </div>
    </button>
  )
}
